export default __webpack_public_path__ + "static/media/tech-blog.acfa1f41.gif";